module.exports = __webpack_public_path__ + "static/media/skoda.96863c77.png";